
import { useState, useEffect } from 'react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  const openReadyAgent = () => {
    const widget = document.querySelector('#vapi-widget-floating-button') as HTMLElement;
    if (widget) {
      widget.click();
    }
  };

  return (
    <header className={`sticky top-0 z-50 transition-all duration-300 ${
      isScrolled 
        ? 'bg-white/95 backdrop-blur-md shadow-lg' 
        : 'bg-white shadow-sm'
    }`}>
      <nav className="px-6 py-4">
        <div className="flex items-center justify-between max-w-7xl mx-auto">
          <div className="flex items-center space-x-2">
            <h1>
              <img 
                src="https://static.readdy.ai/image/d2ead51fc7d35be664515dd1edc2db79/7b497aed7d45596839fc0f74aabd27fa.png" 
                alt="The Pilot Copy" 
                className="h-50 w-auto transition-transform duration-300 hover:scale-105"
              />
            </h1>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('how-it-works')}
              className="text-gray-700 hover:text-[#34444b] font-medium transition-all duration-300 cursor-pointer whitespace-nowrap relative group"
            >
              Services
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#708474] transition-all duration-300 group-hover:w-full"></span>
            </button>
            <button 
              onClick={() => scrollToSection('philosophy')}
              className="text-gray-700 hover:text-[#34444b] font-medium transition-all duration-300 cursor-pointer whitespace-nowrap relative group"
            >
              Philosophy
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#708474] transition-all duration-300 group-hover:w-full"></span>
            </button>
            <button
              onClick={openReadyAgent}
              className="text-gray-700 hover:text-[#708474] font-medium transition-all duration-300 cursor-pointer whitespace-nowrap flex items-center space-x-1 group"
            >
              <i className="ri-chat-3-line group-hover:animate-pulse"></i>
              <span>Chat</span>
            </button>
            <button 
              onClick={() => scrollToSection('final-cta')}
              className="bg-[#34444b] text-white px-6 py-2 rounded-lg hover:bg-[#73807c] transition-all duration-300 font-medium cursor-pointer whitespace-nowrap transform hover:scale-105 hover:shadow-lg"
            >
              Book Strategy Call
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden w-6 h-6 flex items-center justify-center cursor-pointer group"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl text-[#34444b] transition-transform duration-300 ${
              isMenuOpen ? 'rotate-180' : 'group-hover:scale-110'
            }`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        <div className={`md:hidden transition-all duration-300 overflow-hidden ${
          isMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}>
          <div className="mt-4 pb-4 border-t border-gray-100">
            <div className="flex flex-col space-y-4 pt-4">
              <button 
                onClick={() => scrollToSection('how-it-works')}
                className="text-gray-700 hover:text-[#34444b] font-medium text-left cursor-pointer transition-colors duration-300"
              >
                Services
              </button>
              <button 
                onClick={() => scrollToSection('philosophy')}
                className="text-gray-700 hover:text-[#34444b] font-medium text-left cursor-pointer transition-colors duration-300"
              >
                Philosophy
              </button>
              <button
                onClick={openReadyAgent}
                className="text-gray-700 hover:text-[#708474] font-medium text-left cursor-pointer transition-colors duration-300 flex items-center space-x-2"
              >
                <i className="ri-chat-3-line"></i>
                <span>Chat with Sebastian</span>
              </button>
              <button 
                onClick={() => scrollToSection('final-cta')}
                className="bg-[#34444b] text-white px-6 py-2 rounded-lg hover:bg-[#73807c] transition-colors duration-300 font-medium text-left cursor-pointer whitespace-nowrap"
              >
                Book Strategy Call
              </button>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
